module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_10-6ca6e47ba336f2eb283107920402fe41.png";